import { FC, ReactNode } from "react";
import { CircleUser } from "lucide-react";

import { FullLogo } from "@/blocks/FullLogo";
import { RmButton } from "@/components/RmButton/RmButton";
import { RmSheet, RmSheetTrigger } from "@/components/RmSheet";
import { AccountDetails } from "@/interactors/AccountDetails";

type PanelLayoutType = {
  children: ReactNode;
};

export const PanelLayout: FC<PanelLayoutType> = ({ children }) => {
  return (
    <div className="flex flex-1 flex-col gap-6 p-4 pt-7">
      <div className="flex w-full flex-row justify-between">
        <FullLogo className="h-[36px] md:mx-7 md:mr-7" />
        <RmSheet>
          <RmSheetTrigger asChild>
            <RmButton
              variant="ghost"
              i18nKey="common:account"
              iconComponentLeft={<CircleUser />}
            />
          </RmSheetTrigger>
          <AccountDetails />
        </RmSheet>
      </div>
      {children}
    </div>
  );
};
